export default "__VITE_ASSET__DBMUOe8a__"